<div class="dropdown__search-container">
  <input
    type="text"
    [attr.aria-label]="ariaLabel()"
    (focus)="onInputFocus.emit($event)"
    aria-haspopup="listbox"
    (blur)="onInputBlur.emit($event)"
    [disabled]="disabled() || readonly()"
  />

  <div class="dropdown__input-search">
    <rx-input
      type="text"
      autocomplete="off"
      [value]="filterValue() || ''"
      [ngClass]="{ 'is-active': isDropdownOpen() }"
      [placeholder]="placeholder()"
      (keydown.enter)="$event.preventDefault()"
      (input)="onFilter.emit($event)"
      [disabled]="disabled() || readonly()"
    >
    </rx-input>
  </div>
</div>
